export const buildProvenance = { "commitHash": "ede0896aa00cb8388177747aa33cfdb7cf22c65e", "branchName": "refs/heads/release/2025.4", "buildDate": "2026-02-10T17:37:56.696Z", "version": "2025.4.10410" };
